/**
 * 网络配置
 */

import axios from 'axios';
import { getNetworkConfig } from '@ms/shared-config';
import { TokenManager } from '@ms/shared-auth';

const networkConfig = getNetworkConfig('msAi');

// 判断是否为生产环境
const isProduction = typeof window !== 'undefined' && 
  (window.location.hostname === 'ai.ihoms.cn' || 
   window.location.hostname.includes('ihoms.cn'));

// 在生产环境使用相对路径，开发环境使用配置的 URL
const baseURL = isProduction 
  ? '' // 生产环境使用相对路径，让 nginx 代理处理
  : (networkConfig.apiBaseUrl || 'http://localhost:50083');

// 创建 axios 实例
export const apiClient = axios.create({
  baseURL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器：附加 msLogin token（/api/ai/* 开启鉴权后必需）
apiClient.interceptors.request.use(
  (config) => {
    const token = TokenManager.getCurrentToken();
    if (token && !config.headers?.Authorization) {
      config.headers.set('Authorization', `Bearer ${token}`);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error('API 请求失败:', error);
    return Promise.reject(error);
  }
);
